import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import api from '../../../services/api';
import { getSubdomainUsername, getUsernameSyncOnly } from '../../../utils/subdomain';
import { buildMediaUrl } from '../../../utils/mediaUrl';

const PublicWhyChooseUs = () => {
  const { username: urlUsername } = useParams();
  const subdomainUser = getSubdomainUsername();
  const cachedCustomDomainUser = getUsernameSyncOnly();
  const username = urlUsername || subdomainUser || cachedCustomDomainUser;

  const [data, setData] = useState({ section: null, items: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/business/why-choose-us/public/${username}/`);
        // API returns array directly
        const items = Array.isArray(res.data) ? res.data : (res.data.items || []);
        setData({
          section: res.data.section || {},
          items: items
        });
      } catch (err) {
        console.error('Error fetching why choose us:', err);
      } finally {
        setLoading(false);
      }
    };
    if (username) fetchData();
  }, [username]);

  if (loading) {
    return (
      <div style={{ padding: '4rem 2rem', textAlign: 'center' }}>
        <div style={{
          width: '2rem', height: '2rem',
          border: '3px solid rgba(255,255,255,0.1)',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto'
        }} />
      </div>
    );
  }

  if (!data.items.length) {
    return (
      <div id="section-why_choose_us" style={{ padding: '4rem 2rem', textAlign: 'center', backgroundColor: '#1e293b' }}>
        <p style={{ color: 'rgba(255,255,255,0.5)' }}>No content available yet.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '4rem 2rem', backgroundColor: '#1e293b' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '700', color: '#fff', marginBottom: '0.5rem' }}>
            {data.section?.title || 'Why Choose Us'}
          </h2>
          {data.section?.subtitle && (
            <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '1.1rem' }}>
              {data.section.subtitle}
            </p>
          )}
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '2rem'
        }}>
          {data.items.map((item, index) => (
            <div
              key={item.id || index}
              style={{
                padding: '2rem',
                backgroundColor: 'rgba(255,255,255,0.05)',
                borderRadius: '1rem',
                textAlign: 'center'
              }}
            >
              <div style={{
                width: '4rem',
                height: '4rem',
                borderRadius: '50%',
                backgroundColor: 'rgba(99, 102, 241, 0.2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 1rem'
              }}>
                {item.icon ? (
                  <span style={{ fontSize: '1.5rem' }}>{item.icon}</span>
                ) : (
                  <CheckCircle size={28} style={{ color: '#6366f1' }} />
                )}
              </div>
              <h3 style={{ color: '#fff', fontSize: '1.25rem', fontWeight: '600', marginBottom: '0.5rem' }}>
                {item.title}
              </h3>
              <p style={{ color: 'rgba(255,255,255,0.6)', lineHeight: '1.6' }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublicWhyChooseUs;
